import React from 'react'
import { CloudUploadOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useEffect } from 'react';
import axios from 'axios';
import config from '../../../config';
import Swal from 'sweetalert2';
import { useLocation, useNavigate } from 'react-router-dom';
import '../form/productForm.scss';   // import explicite (avant : dépendait d'un chargement ailleurs)
import { NdoePage, NdoePageHeader, NdoeFormSection, NdoeActionButton, NdoeImage } from '../../../components/ndoe';

const FormProduitEdit = () => {
  const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
  const [data, setData] = useState({})
  const [getCategorie, setGetCategorie] = useState([]);
  const [getData, setGetData] = useState([]);
  const [couleur, setCouleur] = useState([]);
  const [getMatiere, setGetMatiere] = useState([]);
  const [getMarque, setGetMarque] = useState();
  const {pathname} = useLocation();
  const id = pathname.split('/')[2]
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);


  const handleInputChange = async (e) => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;

    let updatedValue = fieldValue;

    if (fieldName === "img") {
      const file = e.target.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        const base64File = reader.result;
        updatedValue = base64File;
        setData((prev) => ({ ...prev, [fieldName]: updatedValue }));
      };

      reader.onerror = (error) => {
        console.error("Erreur de lecture du fichier :", error);
      };

      reader.readAsDataURL(file);
    } else if (fieldName === "contact_email") {
      updatedValue = fieldValue.toLowerCase();
    } else if (Number.isNaN(Number(fieldValue))) {
      updatedValue = fieldValue.charAt(0).toUpperCase() + fieldValue.slice(1);
    }

    setData((prev) => ({ ...prev, [fieldName]: updatedValue }));
  };

  useEffect(() => {
    const fetchCategorie = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/produit/categorie`);
        setGetCategorie(data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchCategorie();
  }, [DOMAIN]);

  useEffect(() => {
    const fetchEmplacement = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/produit/emplacement`);
        setGetData(data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchEmplacement();
  }, [DOMAIN]);

  useEffect(() => {
    const fetchCouleur = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/produit/couleur`);
        setCouleur(data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchCouleur();
  }, [DOMAIN]);

  useEffect(() => {
    const fetchMatiere = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/produit/matiere`);
        setGetMatiere(data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchMatiere();
  }, [DOMAIN]);

  useEffect(() => {
    const fetchMarque = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/produit/marque`);
        setGetMarque(data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchMarque();
  }, [DOMAIN]);


  const handleClick = async (e) => {
    e.preventDefault();

    try{
      setIsSaving(true);
      await axios.put(`${DOMAIN}/api/produit/produit/${id}`, data)
      Swal.fire({
        title: 'Success',
        text: 'Le produit a été modifié avec succès.!',
        icon: 'success',
        confirmButtonText: 'OK',
      });
      navigate('/products')   // la liste se recharge à l'arrivée (plus de window.location.reload)
    }catch(err) {
      Swal.fire({
        title: 'Error',
        // Le serveur explique POURQUOI il refuse (« prix en dollars entiers »,
        // « l'état doit être Actif ou Inactif »…). Afficher `err.message` donnait
        // « Request failed with status code 400 », qui n'aide personne.
        text: err.response?.data?.error || err.message,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }finally{
      setIsSaving(false);
    }
  }

  useEffect(() => {
    const fetchProduit = async () => {
      try {
        // `/produitView/:id` N'A JAMAIS EXISTÉ : l'appel échouait, l'erreur
        // partait dans la console et le formulaire restait VIDE. La route qui
        // charge une fiche est `/produit/:id` (getProduitOne).
        const { data } = await axios.get(`${DOMAIN}/api/produit/produit/${id}`);
        setData(Array.isArray(data) ? data[0] : data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchProduit();
  }, [DOMAIN, id]);


  return (
    <NdoePage>
      <div className="productForm">
        <NdoePageHeader eyebrow="Catalogue" title="Modifier un produit" subtitle="Mettre à jour les informations du produit" />

        <NdoeFormSection step={1} title="Identité" hint="Nom, catégorie, couleur, matière, marque" collapsible={false}>
          <div className="ndoe-form-grid">
            <div className="form-controle ndoe-form-grid--full">
              <label>Nom du produit</label>
              <input type="text" name='nom_produit' value={data?.nom_produit ?? ''} className="form-input" placeholder='Entrer le nom...' onChange={handleInputChange} />
            </div>
            <div className="form-controle">
              <label>Catégorie</label>
              <select value={data?.categorie ?? ''} name="categorie" className="form-input" onChange={handleInputChange}>
                <option value="">Sélectionnez une categorie</option>
                {getCategorie?.map((item) => (
                  <option key={item.id} value={item.id}>{item.nom_categorie}</option>
                ))}
              </select>
            </div>
            <div className="form-controle">
              <label>Couleur</label>
              <select value={data?.couleur ?? ''} name="couleur" className="form-input" onChange={handleInputChange}>
                <option value="">Sélectionnez une couleur</option>
                {couleur?.map((item) => (
                  <option key={item.id} value={item.id}>{item.nom_couleur}</option>
                ))}
              </select>
            </div>
            <div className="form-controle">
              <label>Matière</label>
              <select value={data?.matiere ?? ''} name='matiere' className="form-input" onChange={handleInputChange}>
                <option value="">Sélectionnez une matière</option>
                {getMatiere?.map((item) => (
                  <option key={item.id} value={item.id}>{item.nom}</option>
                ))}
              </select>
            </div>
            <div className="form-controle">
              <label>Marques</label>
              <select value={data?.marque ?? ''} name="marque" className="form-input" onChange={handleInputChange}>
                <option value="">Sélectionnez une marque</option>
                {getMarque?.map((item) => (
                  <option key={item.id} value={item.id}>{item.nom}</option>
                ))}
              </select>
            </div>
          </div>
        </NdoeFormSection>

        <NdoeFormSection step={2} title="Stock & prix" hint="Pointure, quantité, emplacement, prix" collapsible={false}>
          <div className="ndoe-form-grid">
            <div className="form-controle">
              <label>Pointure</label>
              <input type="number" name='pointure' value={data?.pointure ?? ''} className="form-input" placeholder='ex: 40' onChange={handleInputChange} />
            </div>
            <div className="form-controle">
              <label>Quantité</label>
              <input type="number" name='quantite_stock' value={data?.quantite_stock ?? ''} className="form-input" placeholder='ex: 10' onChange={handleInputChange} />
            </div>
            <div className="form-controle">
              <label>Emplacement</label>
              <select value={data?.emplacement ?? ''} name="emplacement" className="form-input" onChange={handleInputChange}>
                <option value="">Sélectionnez un emplacement</option>
                {getData?.map((item) => (
                  <option key={item.id} value={item.id}>{item.nom}</option>
                ))}
              </select>
            </div>
            <div className="form-controle">
              <label>Prix</label>
              <input type="number" name='prix' value={data?.prix ?? ''} className="form-input" placeholder='ex: 100$' onChange={handleInputChange} />
            </div>
          </div>
        </NdoeFormSection>

        <NdoeFormSection step={3} title="Description" collapsible={false}>
          <div className="form-controle-desc">
            <textarea name="description" value={data?.description ?? ''} placeholder='Description.....' onChange={handleInputChange}></textarea>
          </div>
        </NdoeFormSection>

        <NdoeFormSection step={4} title="Image" hint="Formats acceptés : JPG, PNG" collapsible={false}>
          <div className="form-controleFile" onClick={() => document.getElementById('file-upload').click()}>
            <label>Image du produit</label>
            <input type="file" name='img' className="form-input" style={{display:"none"}}
              id='file-upload'
              accept='.jpeg, .png, .jpg' onChange={handleInputChange} />
            <div className="form-file">
              <CloudUploadOutlined className='cloud-icon' />
              <span>Glissez et déposez un fichier à télécharger</span>
            </div>
          </div>
          {data?.img &&
            <NdoeImage src={data.img} alt="Aperçu du produit" size={160} />}
        </NdoeFormSection>

        <div className="ndoe-sticky-cta">
          <NdoeActionButton variant="secondary" onClick={() => navigate('/products')}>Annuler</NdoeActionButton>
          <NdoeActionButton variant="primary" onClick={handleClick} loading={isSaving}>Modifier</NdoeActionButton>
        </div>
      </div>
    </NdoePage>
  )
}

export default FormProduitEdit
